import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  fileContainer: {
    minHeight: '100px',
    maxHeight: '100px',
    height: '100px',
    minWidth: '120px',
    maxWidth: '150px',
    position: 'relative',
    overflow: 'visible',
  },

  buttonsContainer: {
    position: 'absolute',
    top: '2px',
    right: '2px',
    zIndex: 1000,
    cursor: 'pointer',

    '& svg': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: '10px',
      transition: 'color 0.15s linear',
    },

    '& svg + svg': {
      marginLeft: '2px',
    },
  },

  fileWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },

  img: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    borderRadius: '10px',

    '& svg': {
      fontSize: '16px',
    },
  },

  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },

  footer: {
    height: '40px',
    zIndex: 1,
    background: theme.palette.grey[50],
    padding: '0 8px',
    borderRadius: '0 0 4px 4px',
    position: 'absolute',
    bottom: '-1px',
    width: '100%',
  },

  fileName: {
    fontWeight: 500,
    lineHeight: '21px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      marginRight: '4px',
    },
  },

  createdAt: {
    fontWeight: 500,
    fontSize: '10px',
    lineHeight: '21px',
    color: theme.palette.grey[600],
  },

  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',

    '& svg': {
      fontSize: '40px !important',
    },
  },

  fileItemButtons: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px',
    top: '0',
    left: '0',
    position: 'absolute',
    zIndex: 2,
  },

  video: {},
}));
